import { useEffect, useState } from 'react';
import { getDatabase, ref, onValue, push } from 'firebase/database';

// Firebase keys can't contain . / [ ] # $
const encodeKey = (name) => name.replace(/[./#$[\]]/g, '_');

const useReactions = (trackName) => {
  const [reactions, setReactions] = useState([]);

  useEffect(() => {
    if (!trackName) {
      setReactions([]);
      return;
    }

    const db = getDatabase();
    const unsub = onValue(ref(db, `reactions/${encodeKey(trackName)}`), (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setReactions(Object.entries(data).map(([id, val]) => ({ id, ...val })));
      } else {
        setReactions([]);
      }
    });

    return unsub;
  }, [trackName]);

  const addReaction = (emoji, songTimestamp) => {
    if (!trackName) return;
    const db = getDatabase();
    push(ref(db, `reactions/${encodeKey(trackName)}`), {
      emoji,
      songTimestamp,
      createdAt: Date.now(),
    });
  };

  return { reactions, addReaction };
};

export default useReactions;
